import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "authentication-wrapper authentication-2 px-4" }
const _hoisted_2 = { class: "authentication-inner py-5" }
const _hoisted_3 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-danger"
}
const _hoisted_9 = {
  key: 0,
  class: "text-center"
}
const _hoisted_10 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.imageURL,
            alt: _ctx.partner +' Logo',
            title: _ctx.partner +' Logo',
            height: "75",
            class: "cursor-pointer partner-logo",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.frontEndPartner && _ctx.frontEndPartner(...args)))
          }, null, 8, _hoisted_4)
        ]),
        (_ctx.showForm)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "card",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-center text-muted mb-4" }, "Reset Your Password", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1)),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, "Enter your email address and we will send you a link to reset your password.", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    name: "email",
                    type: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email.value) = $event)),
                    autocomplete: "email",
                    disabled: _ctx.loading,
                    required: "",
                    class: _normalizeClass([_ctx.form.email.valid ? '' : 'border-danger', "form-control"]),
                    placeholder: "Enter your email address"
                  }, null, 10, _hoisted_7), [
                    [_vModelText, _ctx.form.email.value]
                  ]),
                  (!_ctx.form.email.valid)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.form.email.validationMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary btn-block w-100 mt-3"
                }, "Send password reset email", -1))
              ])
            ], 32))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (!_ctx.showForm)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "mt-2 font-medium text-primary",
              to: "/login/"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Back to Login")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_loading, { active: _ctx.loading }, null, 8, ["active"])
  ], 64))
}